module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ep-transfer"
  }, [_vm._t("select"), _vm._v(" "), _c('div', {
    staticClass: "ep-transfer__buttons"
  }, [_c('div', {
    class: ['ep-tranfer_button', {
      'ep-tranfer_bactive': _vm.select.length > 0
    }],
    on: {
      "click": function($event) {
        _vm.confirm_controll('select')
      }
    }
  }, [_vm._t("sbtn")], 2), _vm._v(" "), _c('div', {
    class: ['ep-tranfer_button', {
      'ep-tranfer_bactive': _vm.result.length > 0
    }],
    on: {
      "click": function($event) {
        _vm.confirm_controll('result')
      }
    }
  }, [_vm._t("rbtn")], 2)]), _vm._v(" "), _vm._t("result")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c4bf42","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/transfer/src/transfer.vue
// module id = 1184
// module chunks = 2